module.exports = __webpack_public_path__ + "img/drop-right-dark.b39d2e9c.svg";